// extracted by mini-css-extract-plugin
export default {"styleCenterAndFixed":"fkb5Rt","text":"Pej8jm","subtitle":"Ly6cY4","title":"kY6F_3","refreshButton":"u7Wv7W"};